import useDrivePicker from 'react-google-drive-picker';

import { GOOGLE_DRIVE_PICKER_ENABLED } from '../utils/keys';

// The real hook injects Google's scripts on mount, so a build without the
// picker gets a no-op instead. The choice is fixed at build time, so the same
// hook runs on every render.
const useNoDrivePicker = () => [() => {}, undefined];

export default GOOGLE_DRIVE_PICKER_ENABLED ? useDrivePicker : useNoDrivePicker;
